module.exports = __webpack_public_path__ + "static/media/menu.e65ca7cf.svg";